// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA3uY7UcII_BVDoGoHlcRzYMeAQTtjkeI8",
    authDomain: "qring-5a533.firebaseapp.com",
    projectId: "qring-5a533",
    storageBucket: "qring-5a533.appspot.com",
    messagingSenderId: "261913302441",
    appId: "1:261913302441:web:fcd5eb221e2176687c20b8",
    measurementId: "G-6SYTLF7SH2",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };
